import { apiClientHeader } from "./apiClientHeader"
const updateApiClientHeader = function (option) {
  if (typeof option === 'object') {
    for (let key in option) {
      apiClientHeader[key] = option[key] ? option[key] : ''
    }
  }
}
export default updateApiClientHeader
